import { DeleteTreeOverlay } from '@fs/zion-group-management'
import { ContentDelete, NoticeWarning } from '@fs/zion-icon'
import { useGroupsContext } from '@fs/zion-tree-groups'
import { Button, Card, colors, H3, Paragraph, Row, Separator, Skeleton, useOverlay } from '@fs/zion-ui'
import React from 'react'
import { useHistory } from '@fs/zion-router'
import { useEvent } from '@fs/zion-frontend-friends'
import { useTranslation } from 'react-i18next'
import { useTreeGroupDetailsContext } from '../providers/TreeGroupDetailsProvider'
import { useGedcomData } from '../../providers/GedcomDataProviderSmart'

export default function DeleteTree(): JSX.Element {
  const [t] = useTranslation()
  const { getAndSetGroups } = useGroupsContext()
  const deleteTreeOverlay = useOverlay()
  const { group } = useTreeGroupDetailsContext()
  const { gedcomData } = useGedcomData()

  const history = useHistory()

  const onDeleteTree = useEvent(() => {
    getAndSetGroups?.(true)
    history.push('/research-tree')
  })

  return (
    <div>
      <H3 size="H6">{t('group-management.delete-researcher-group.action')}</H3>

      <Separator size="nano" />

      <Paragraph size="sm">{t('group-management.delete-tree.description')}</Paragraph>

      <Separator size="nano" />

      <Card backgroundColor={colors.gray03} edges="none" margins="xs">
        <Row alignY="middle" gutters="xs">
          <NoticeWarning size="xs" color={colors.yellow50} />
          <Paragraph size="sm">{t('group-management.delete-tree.warning')}</Paragraph>
        </Row>
      </Card>

      <Separator size="nano" />
      <Button data-testid="delete-tree-button" Icon={ContentDelete} onClick={deleteTreeOverlay.handleClick}>
        {t('group-management.delete-tree.action')}
      </Button>

      {(deleteTreeOverlay.isOpen || deleteTreeOverlay.transitioning) && (
        <DeleteTreeOverlay
          overlay={deleteTreeOverlay}
          groupId={group.id}
          fileName={gedcomData?.fileName}
          onDeleteTree={onDeleteTree}
        />
      )}
    </div>
  )
}

export function DeleteTreeSkeleton(): JSX.Element {
  return (
    <div>
      <Skeleton.H6 />

      <Separator size="nano" />

      <Paragraph size="sm">
        <Skeleton.Paragraph maxWidth={200} />
      </Paragraph>

      <Separator size="nano" />

      <Card backgroundColor={colors.gray03} edges="none" margins="xs">
        <Row alignY="middle" gutters="xs">
          <Skeleton.Icon size="xs" />
          <Paragraph size="sm">
            <Skeleton.Paragraph maxWidth={250} />
          </Paragraph>
        </Row>
      </Card>

      <Separator size="nano" />
      {/* eslint-disable-next-line test-selectors/button -- NA */}
      <Skeleton.Button />
    </div>
  )
}
